export const EXPORT_TO_FILE_CONSTS = {
  inCSV: 'в формате CSV',
  inPDF: 'в формате PDF',
  inXLS: 'в формате XLS',
  inXML: 'в формате XML',
  inWord: 'в формате Word',
  export: 'Экспорт'
}
